import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'enumLabel'
})
export class EnumLabelPipe implements PipeTransform {

    transform(value: any, enumClass): string {
        if (!enumClass) {
            return 'Argument missed [enumClass], usage: {{enumValue|enumLabel:enumClass|translate}}';
        }
        return `Enum.${Object.keys(enumClass).filter(k => typeof k === 'string')[Object.values(enumClass).indexOf(value)]}`;
    }

}
